import * as angular from 'angular';

import { IRequestService } from '../request.service';
import { LastProcessingResult, LastProcessingResultByGroup } from '../../models';

export interface IlastProcessingResultsService {
    getLastProcessingResults(beginDate: string, endDate: string): angular.IPromise<LastProcessingResult[]>;
    getLastProcessingResults(beginDate: string, endDate: string, force: boolean): angular.IPromise<LastProcessingResult[]>;
    getLastProcessingResultsByGroup(beginDate: string, endDate: string): angular.IPromise<LastProcessingResultByGroup>;
    getLastProcessingResultsByGroup(beginDate: string, endDate: string, force: boolean): angular.IPromise<LastProcessingResultByGroup>;
}

export class LastProcessingResultsService implements IlastProcessingResultsService {

    static serviceId = 'lastProcessingResultsService';
    static $inject = ['requestService'];

    private _controllerUrl = 'lastProcessingResults';

    constructor(private _requestService: IRequestService) {
    }

    getLastProcessingResults(beginDate: string, endDate: string, force: boolean = false): angular.IPromise<LastProcessingResult[]> {
        if (force) {
            this._requestService.cleanCacheAtV1(this._controllerUrl, { beginDate, endDate });
        }
        return this._requestService.getAtV1(this._controllerUrl, { beginDate, endDate });
    }

    getLastProcessingResultsByGroup(beginDate: string, endDate: string, force: boolean = false): angular.IPromise<LastProcessingResultByGroup> {
        const url = `${this._controllerUrl}/byGroup`;
        if (force) {
            this._requestService.cleanCacheAtV1(url, { beginDate, endDate });
        }
        return this._requestService.getAtV1(url, { beginDate, endDate });
    }
}